export const getProvider = (chain) => {
  if (chain == "ETH") {
    return "https://mainnet.infura.io/v3/3c17ac2e2c3b4194a94d82acefa266bb";
  } else if (chain == "BSC") {
    return "https://bsc-mainnet.web3api.com/v1/3YDSX619RGTQ5I3CHND26GHFUUY47ES48V";
  }
};
